import { formatCurrency } from '@/lib/utils'
import { type AccidentViolationItem, AccidentViolationSource } from '@/models/dashboard'

export const SOURCE_LABELS: Record<AccidentViolationSource, string> = {
  [AccidentViolationSource.LOSS_RUN]: 'Loss run',
  [AccidentViolationSource.CAB]: 'FMCSA',
  [AccidentViolationSource.TERMINAL]: 'Motive',
}

export function isClaim(item: AccidentViolationItem): boolean {
  return item.source === AccidentViolationSource.LOSS_RUN
}

export function formatEventDate(dateStr: string | null | undefined): string {
  if (!dateStr) return '—'
  return new Date(dateStr + 'T00:00:00').toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  })
}

/** Whole-dollar amount for table cells; em-dash when the figure is unknown. */
export function formatAmount(amount: number | null | undefined): string {
  if (amount === null || amount === undefined) return '—'
  return formatCurrency(amount, { minimumFractionDigits: 0, maximumFractionDigits: 0 })
}

export function maskVin(vin?: string): string {
  if (!vin || vin.length < 4) return vin || ''
  return '•••' + vin.slice(-4)
}

/** Claim number for claims, the event title for FMCSA/telematics rows. */
export function referenceLabel(item: AccidentViolationItem): string {
  if (isClaim(item)) return item.claimNumber || item.claimReference || '—'
  return item.title || '—'
}

/** Coverage for claims, the humanized event type for FMCSA/telematics rows. */
export function categoryLabel(item: AccidentViolationItem): string {
  if (isClaim(item)) return item.coverageLabel || '—'
  return item.type.replace(/_/g, ' ')
}
